module.exports = __webpack_public_path__ + "files/fdefa66a1122f59acf5c1995c60e118f.svg";